// Vitalöm add-to-cart helper: adds via AJAX and triggers Horizon's cart drawer
// (refresh + auto-open) by dispatching the standard CartLinesUpdateEvent.
import { CartLinesUpdateEvent } from '@shopify/events';

async function vlAdd(id, qty, sourceEl, sellingPlan) {
  const target = sourceEl || document.body;
  const deferred = CartLinesUpdateEvent.createPromise();

  const line = { merchandiseId: String(id), quantity: Number(qty) };
  if (sellingPlan) line.sellingPlanId = String(sellingPlan);
  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [line],
      promise: deferred.promise,
    })
  );

  const item = { id: Number(id), quantity: Number(qty) };
  if (sellingPlan) item.selling_plan = Number(sellingPlan);
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    if (!res.ok) {
      let msg = 'No se pudo agregar al carrito';
      try { const e = await res.json(); msg = e.description || e.message || msg; } catch (_) {}
      throw new Error(msg);
    }
    const cart = await (await fetch('/cart.js')).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'vl-atc', itemCount: Number(qty) },
    });
  } catch (err) {
    deferred.reject(err);
    throw err;
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('[data-vl-add]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.getAttribute('data-vid');
  if (!id || btn.disabled) return;

  let qty = 1;
  const bundle = btn.closest('.vl-bundle');
  if (bundle) {
    const r = bundle.querySelector('.vl-bcard input:checked, .vl-tier input:checked');
    if (r) qty = parseInt(r.value, 10) || 1;
  } else {
    qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
  }

  let plan = null;
  const scope = btn.closest('.vl');
  if (scope) {
    const pur = scope.querySelector('.vl-purchase input:checked');
    if (pur && pur.value === 'sub') {
      const tier = scope.querySelector('.vl-bcard input:checked');
      const card = tier ? tier.closest('.vl-bcard') : null;
      if (card) plan = card.getAttribute('data-plan');
    }
  }

  btn.disabled = true;
  btn.style.opacity = '0.75';
  vlAdd(id, qty, btn, plan)
    .catch((err) => { window.alert(err && err.message ? err.message : 'No se pudo agregar al carrito'); })
    .finally(() => { btn.disabled = false; btn.style.opacity = '1'; });
});
